import { crudMutations, crudActions } from './modules/action-helpers'

const basePath = 'api/worksheet'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    currentItem: null
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...crudActions({ basePath: basePath })
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/worksheets.js